<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',   
    metaInfo: {
      title: 'Home ',
      titleTemplate: '%s | CARLOS HUMBERTO',
      meta: [{
            name: 'robots',
            content: 'index, follow',
        }]
    },
    
    watch: {
        $route(to){

            console.log('TO', to);
          
            //this.gaTrack(to.path);

            setTimeout(function(){
            

                if(to.hash){

                    var elem = document.querySelector('section' + to.hash);
                    window.scrollTo( 0, elem.offsetTop);

                } else {
                    
                    window.scrollTo( 0, 0);

                }

            }, 1000)

        }
  
    },
}
</script>

<style lang="less">
    @import "@less/vars.less";
    @import "@less/base.less";
</style>